module.exports = __webpack_public_path__ + "static/media/award.964d7aee.svg";